import api from './api';

export const getProjectBudget = (projectId) =>
  api.get(`/projects/${projectId}/budget`);

export const upsertProjectBudget = (projectId, data) =>
  api.put(`/projects/${projectId}/budget`, data);
